var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('div', { staticClass: "tabs-modular" }, [_c('el-tabs', { on: { "tab-click": _vm.tabClickHandle }, model: { value: _vm.activeName, callback: function callback($$v) {
        _vm.activeName = $$v;
      }, expression: "activeName" } }, _vm._l(_vm.tabMapOptions, function (item) {
    return _c('el-tab-pane', { key: item.value, attrs: { "label": !item.value ? item.label : item.label + '库', "name": String(item.value) } });
  }), 1)], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };